import { Modal } from "antd";

export function ModalComponent({
  key,
  title,
  children,
  modalContent,
  footer,
  isModalOpen,
  setOpen,
  onOpen,
  style,
  ...props
}) {
  const showModal = (e) => {
    e.stopPropagation(); // Prevents event bubbling
    if (setOpen == null) {
      throw new Error(
        "hook const [isModalOpen, setIsModalOpen] = useState(false); is required"
      );
    }
    setOpen(true);
    if (onOpen != null) onOpen();
  };
  const hideModal = () => {
    if (setOpen == null) {
      throw new Error(
        "hook const [isModalOpen, setIsModalOpen] = useState(false); is required"
      );
    }
    setOpen(false);
  };

  return (
    <div key={key}>
      <div onClick={showModal} style={{ cursor: "pointer" }}>
        {children}
      </div>

      <Modal
        {...props}
        title={title}
        open={isModalOpen}
        onOk={hideModal}
        onCancel={() => hideModal()}
        footer={footer ? footer : null}
        style={{
          top: 20,
          ...style,
        }}
      >
        {modalContent}
      </Modal>
    </div>
  );
}
